module.exports = __webpack_public_path__ + "static/media/bg-intro.08314705.jpg";